import React from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormFields, FormTextField } from "sprint-common-web";

import { validateAsperaKey } from "../../common/validateAsperaKey";
import { useCreateAsperaDeliveryEndpointForm } from "./useCreateAsperaDeliveryEndpointForm";

export interface CreateDeliveryEndpointFormProps {
    onCancel(): void;
    onSubmit(): void;
}

export interface CreateDeliveryEndpointFormInputs {
    name: string;
    url: string;
    user: string;
    ssmPrivateKeyName: string;
    workspace?: string;
}

export const CreateAsperaDeliveryEndpointForm: React.VFC<CreateDeliveryEndpointFormProps> = ({
    onSubmit,
    onCancel
}: CreateDeliveryEndpointFormProps) => {
    const { addDeliveryEndpoint } = useCreateAsperaDeliveryEndpointForm();

    const { errors, control, formState, handleSubmit, reset } = useForm<CreateDeliveryEndpointFormInputs>({
        defaultValues: {
            name: "",
            url: "",
            user: "",
            ssmPrivateKeyName: "",
            workspace: ""
        },
        criteriaMode: "all"
    });

    const handleCreateDeliveryEndpoint = async (inputs: CreateDeliveryEndpointFormInputs) => {
        await addDeliveryEndpoint(inputs);
        onSubmit();
    };

    const handleCancelButtonClick = () => {
        reset();
        onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleCreateDeliveryEndpoint)}>
            <FormFields>
                <FormTextField
                    label="Name"
                    control={control}
                    name="name"
                    errors={errors}
                    rules={{ required: "Enter name" }}
                />
                <FormTextField
                    label="Url"
                    control={control}
                    name="url"
                    errors={errors}
                    rules={{ required: "Enter url" }}
                />
                <FormTextField
                    label="User"
                    control={control}
                    name="user"
                    errors={errors}
                    rules={{ required: "Enter user" }}
                />
                <FormTextField
                    label="Smm private key name"
                    control={control}
                    name="ssmPrivateKeyName"
                    errors={errors}
                    rules={{
                        validate: validateAsperaKey,
                        required: "Enter ssm private key name"
                    }}
                />
                <FormTextField label="Workspace" control={control} name="workspace" errors={errors} />
            </FormFields>
            <FormActions
                isLoading={formState.isSubmitting || formState.isValidating}
                onCancel={handleCancelButtonClick}
            />
        </Form>
    );
};
